import type { ReactNode } from 'react'

import { useHasAnyRole } from './auth-context'

export interface RequireRoleProps {
  /** Die benötigte Rolle. */
  role?: string
  /** Alternativ: eine dieser Rollen genügt. */
  anyOf?: string[]
  /** Was stattdessen erscheint, wenn die Rolle fehlt. Standard: nichts. */
  fallback?: ReactNode
  children: ReactNode
}

/**
 * Zeigt seinen Inhalt nur, wenn der Nutzer die Rolle hat.
 *
 * Wichtig: das ist eine Anzeigeentscheidung, keine Sicherheitsgrenze. Die
 * eigentliche Prüfung macht immer das Backend — hier geht es darum, dem Nutzer
 * keine Knöpfe zu zeigen, die er nicht drücken darf.
 *
 * @example
 * ```tsx
 * <RequireRole role="wartung.freigabe">
 *   <Button onClick={freigeben}>Freigeben</Button>
 * </RequireRole>
 * ```
 */
export function RequireRole({ role, anyOf, fallback = null, children }: RequireRoleProps) {
  const required = anyOf ?? (role ? [role] : [])
  const allowed = useHasAnyRole(required)
  return <>{allowed ? children : fallback}</>
}
